module.exports = __webpack_public_path__ + "static/media/eventPopup.5b66a616.jpg";